import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import "./LanguageSelection.css";

// Recebe lista de linguagens em array

const LanguageSelection = ({ languages }) => {
  const isHomepage = null;
  const { i18n, t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const languageButtonRef = useRef(null);
  const [selectedLanguage, setSelectedLanguage] = useState((i18n.language || "en").split("-")[0].toUpperCase());

  useEffect(() => {
    document.documentElement.lang = (i18n.language || "en").split("-")[0];
    setSelectedLanguage((i18n.language || "en").split("-")[0].toUpperCase());
  }, [i18n.language]);

  const toggleLanguageSelection = () => {
    setIsOpen(!isOpen);
  };

  const handleLanguageSelect = (language) => {
    setSelectedLanguage(language);
    i18n.changeLanguage(language.toLowerCase());
    setIsOpen(false);
    requestAnimationFrame(() => languageButtonRef.current?.focus());
  };

  return (
    <div className={`language-selection ${isOpen ? "open" : ""}`}>
      <div
        tabIndex={0}
        role="button"
        ref={languageButtonRef}
        aria-label={t("language")}
        aria-expanded={isOpen}
        onClick={toggleLanguageSelection}
        onKeyDown={(event) => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            toggleLanguageSelection();
          }
        }}
        className="language-selection-button"
      >
        <div className="language-selection-selected-container">
          <div
            className={`language-selection-selected ${
              isHomepage ? "homepage" : ""
            } `}
          >
            {selectedLanguage}
          </div>
          {/* {isOpen ? (
            <div className={`img-close ${isHomepage ? "homepage" : ""} `}>
              <img src={UpArrow} alt="" />
            </div>
          ) : (
            <div
              className={`img-close closed ${isHomepage ? "homepage" : ""} `}
            >
              <img src={UpArrow} alt="" />
            </div>
          )} */}
        </div>
      </div>

      {isOpen && (
        <div className="language-selection-menu-container">
          <ul className="language-selection-menu">
            {languages
              .filter((language) => language !== selectedLanguage)
              .map((language, index, array) => (
                <React.Fragment key={language}>
                  <li
                    key={language}
                    tabIndex={0}
                    role="button"
                    onClick={() => handleLanguageSelect(language)}
                    onKeyDown={(event) => {
                      if (event.key === "Enter" || event.key === " ") {
                        event.preventDefault();
                        handleLanguageSelect(language);
                      }
                    }}
                  >
                    {language}
                  </li>
                  {index < array.length - 1 && (
                    <div className="separator-languages">
                      <div className="separator-languages-line"> </div>
                    </div>
                  )}
                </React.Fragment>
              ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default LanguageSelection;
